document.addEventListener('DOMContentLoaded', function() {
    // Your code here
    // Image lazy load handling
    const allMediaSections = document.querySelectorAll('.media-container');
    const allImgsSwitcherWrappers = document.querySelectorAll('.banner-with-switching-images');
    const allAlbumSections = document.querySelectorAll('.album-section');
    var device = window.innerWidth < 768 ? 'mobile' : 'desktop';
    function reload() {
        allMediaSections.forEach(section => {
            loadMedia(section);
        })
        allImgsSwitcherWrappers.forEach(section => {
            loadMediaForImgsSwitcherWrapper(section);
        })
    }
    function windowResizeHandler() {
        window.addEventListener('resize', () => {
            let newDevice = window.innerWidth < 768 ? 'mobile' : 'desktop';
            if (newDevice !== device) {
                console.log("device changed from", device, "to", newDevice);
                device = newDevice;
                reload();
            }
        })
    }
    function loadMedia(container) {
        // Handle responsive image sizes
        const imgs = container.querySelectorAll(device=="mobile"?'img.lazyload-mobile':'img.lazyload');
        console.log("loading media for device:", device, imgs);
        imgs.forEach(img => {
            if (!img.dataset.srcset) return; //If it is removed, that means image is already loaded
            img.srcset = img.dataset.srcset;
            //after image load add show class
            img.onload = () => {container.classList.add('show');}
            img.removeAttribute('data-srcset');
        });
        const vids = container.querySelectorAll(device=="mobile"?'video.lazyload-mobile':'video.lazyload');
        console.log("loading media for device:", device, vids);
        vids.forEach(vid => {
            if (!vid.querySelector("source").dataset.src) return; //If it is removed, that means video is already loaded
            vid.querySelector("source").src = vid.querySelector("source").dataset.src;
            //after video load add show class
            container.classList.add('show')
            vid.querySelector("source").removeAttribute('data-src');
        });
    }
    function setupIntersectionObserversForMediaSections() {
        const handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    //Load the media in this media section
                    loadMedia(entry.target);
                    console.log('Loading media for section:', entry.target);
                    observer.unobserve(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            rootMargin: '50px 0px' 
        });
        allMediaSections.forEach(mediaSection => {    
            observer.observe(mediaSection);
        });
    }
    function startAnimation(switcherImgsContainer, allSwitcherImgs) {
        //Immediately hide first image and show second, then switch every 1 second
        let currentIndex = parseInt(switcherImgsContainer.dataset.currentIndex) || 0;
        const totalImages = allSwitcherImgs.length;
        //Every 1.5 seconds, change the image
        setInterval(() => {
            // If not last image, hide the current index and show the next
            if (currentIndex < totalImages - 1) {
                allSwitcherImgs[currentIndex].classList.remove('active');
                currentIndex += 1;
                allSwitcherImgs[currentIndex].classList.add('active');
            } else {
                //Show the first image and then hide the last
                allSwitcherImgs[0].classList.add('active');
                allSwitcherImgs[currentIndex].classList.remove('active');
                currentIndex = 0;
            }
            switcherImgsContainer.dataset.currentIndex = currentIndex;
        }, 800);
    }
    function checkIfLoadedAndStartAnimation(switcherImgsContainer, allSwitcherImgs) {
        //Ever 1 seconds check if all images in allSwitcherImgs are loaded
        const interval = setInterval(() => {
            const allLoaded = Array.from(allSwitcherImgs).every(img => !img.dataset.src);
            if (allLoaded) {
                clearInterval(interval);
                //Start the animation
                startAnimation(switcherImgsContainer,allSwitcherImgs);
            }
        }, 1000);
    }
    function loadOtherImages(switcherImgsContainer,allSwitcherImgs){
        for (let i = 1; i < allSwitcherImgs.length; i++) {
            const img = allSwitcherImgs[i];
            if (img?.dataset?.src) {
                img.src = img.dataset.src;
                img.onload = () => {
                    img.removeAttribute('data-src');
                }
            }
        }
        checkIfLoadedAndStartAnimation(switcherImgsContainer,allSwitcherImgs)
    }
    function loadMediaForImgsSwitcherWrapper(wrapper) {
        const switcherImgsContainer = wrapper.querySelector(device=="mobile"?'.mobile-switcher-imgs':' .desktop-switcher-imgs');
        console.log("loading media for switch container", device, switcherImgsContainer);
        if (!switcherImgsContainer) return;
        const allSwitcherImgs = switcherImgsContainer.querySelectorAll('.switcher-img');
        //First load the first item in allSwitcherImgs
        //The load the rest
        if (allSwitcherImgs.length > 0) {
            const firstImg = allSwitcherImgs[0];
            if (firstImg?.dataset?.src) {
                firstImg.src = firstImg.dataset.src;
                firstImg.onload = () => {
                    firstImg.removeAttribute('data-src');
                    //Add active class to first image
                    firstImg.classList.add('active');
                    //Need to do animation only if there is more than 1 image
                    if (allSwitcherImgs.length > 1) {
                        loadOtherImages(switcherImgsContainer, allSwitcherImgs);
                    }
                }
            } else {
                if (allSwitcherImgs.length > 1) {
                    loadOtherImages(switcherImgsContainer, allSwitcherImgs);
                }
            }
        }
        //Once all images are loaded, start the animation
    
    }
    function setupIntersectionObserversForImgsSwitcherWrappers() {
        const handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    //Load the media in this media section
                    loadMediaForImgsSwitcherWrapper(entry.target);
                    console.log('Loading media for imgs switcher:', entry.target);
                    observer.unobserve(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            rootMargin: '200px 0px' 
        });
        allImgsSwitcherWrappers.forEach(wrapper => {    
            observer.observe(wrapper);
        });
    }
    function mobileMenuHandlers() {
        const hamburgerMenu = document.querySelector('.hamburger-menu');
        const body = document.body;
        const closeMenuDrawer = document.querySelector('.close-menu-drawer');
        console.log("doms", hamburgerMenu, body, closeMenuDrawer);
        hamburgerMenu?.addEventListener('click', () => {
            body?.classList.add('menu-drawer-open');
        });
        closeMenuDrawer?.addEventListener('click', () => {
            body?.classList.remove('menu-drawer-open');
        });
    }

    function setupAlbumScrollAnimation() {
        allAlbumSections.forEach(albumSection => {
            const albumImages = albumSection.querySelector('.album-images');
            const albumImageItems = albumSection.querySelectorAll('.album-image');
            const albumWrapper = albumSection.closest('.album-section-wrapper');
            
            if (!albumImages || albumImageItems.length === 0) return;

            // Force layout calculation
            albumImages.style.width = 'max-content';
            
            // Calculate the total width needed to scroll through all images
            let totalImagesWidth = 0;
            albumImageItems.forEach(img => {
                totalImagesWidth += img.offsetWidth;
            });
            
            const containerWidth = window.innerWidth;
            const maxTranslateX = Math.max(0, totalImagesWidth - containerWidth);
            
            if (maxTranslateX > 0) {
                // Calculate proper wrapper height: just enough for the animation
                const sectionHeight = albumSection.offsetHeight;
                const scrollDistanceNeeded = maxTranslateX;
                // Remove the buffer - we'll handle smooth exit differently
                const wrapperHeight = sectionHeight + scrollDistanceNeeded;
                
                albumWrapper.style.height = `${wrapperHeight}px`;
                
                // Store values
                albumSection.dataset.maxTranslateX = maxTranslateX;
                albumSection.dataset.scrollDistanceNeeded = scrollDistanceNeeded;
                albumSection.dataset.sectionHeight = sectionHeight;
                albumSection.dataset.wrapperHeight = wrapperHeight;
                
                console.log('Album setup:', {
                    totalImagesWidth,
                    containerWidth,
                    maxTranslateX,
                    sectionHeight,
                    scrollDistanceNeeded,
                    wrapperHeight
                });
            }
        });
    }

    function handleAlbumScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        allAlbumSections.forEach(albumSection => {
            const albumImages = albumSection.querySelector('.album-images');
            const albumWrapper = albumSection.closest('.album-section-wrapper');
            
            if (!albumImages) return;

            const maxTranslateX = parseFloat(albumSection.dataset.maxTranslateX) || 0;
            const scrollDistanceNeeded = parseFloat(albumSection.dataset.scrollDistanceNeeded) || 0;
            const sectionHeight = parseFloat(albumSection.dataset.sectionHeight) || 0;
            const wrapperHeight = parseFloat(albumSection.dataset.wrapperHeight) || 0;
            
            if (maxTranslateX <= 0) return;
            
            // Get the position of the wrapper relative to viewport
            const wrapperRect = albumWrapper.getBoundingClientRect();
            const wrapperTop = wrapperRect.top;
            const wrapperBottom = wrapperRect.bottom;
            
            // Calculate how far we've scrolled into the wrapper
            const scrollIntoWrapper = Math.max(0, -wrapperTop);
            
            if (wrapperTop <= 0 && wrapperBottom > 0) {
                // We're in the wrapper area
                
                if (scrollIntoWrapper <= scrollDistanceNeeded) {
                    // Still in animation phase
                    albumSection.classList.add('album-sticky');
                    
                    // Calculate translation progress (0 to 1)
                    const scrollProgress = Math.min(1, scrollIntoWrapper / scrollDistanceNeeded);
                    const translateX = scrollProgress * maxTranslateX;
                    
                    albumImages.style.transform = `translateX(-${translateX}px)`;
                    
                } else {
                    // Animation complete but still in wrapper - keep sticky with final position
                    albumSection.classList.add('album-sticky');
                    albumImages.style.transform = `translateX(-${maxTranslateX}px)`;
                }
                
            } else if (wrapperBottom <= 0) {
                // Past the wrapper completely - remove sticky and keep final position
                albumSection.classList.remove('album-sticky');
                albumImages.style.transform = `translateX(-${maxTranslateX}px)`;
                
            } else {
                // Before the wrapper - reset everything
                albumSection.classList.remove('album-sticky');
                albumImages.style.transform = 'translateX(0px)';
            }
        });
    }

    function setupAlbumScrollListeners() {
        // Initial setup
        setupAlbumScrollAnimation();
        
        // Handle scroll
        let ticking = false;
        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(() => {
                    handleAlbumScroll();
                    ticking = false;
                });
                ticking = true;
            }
        }
        
        window.addEventListener('scroll', requestTick);
        
        // Recalculate on resize
        window.addEventListener('resize', () => {
            setupAlbumScrollAnimation();
            handleAlbumScroll();
        });
    }
    windowResizeHandler();
    setupIntersectionObserversForMediaSections();
    setupIntersectionObserversForImgsSwitcherWrappers();
    setupAlbumScrollListeners();
    mobileMenuHandlers();
});